import { Box, Button, Center, Stack, Text } from "@chakra-ui/react";
import InputTextGroup from "components/inputs/InputTextGroup";
import InputCheckboxGroup from "components/inputs/InputCheckboxGroup";
import { IAuthRegisterDto } from "dtos/auth.dto";
import { useTranslation } from "next-i18next";
import { useForm } from "react-hook-form";
import AuthSocialLogin from "./AuthSocialLogin";

type AuthRegisterFormProps = {
  loading?: boolean;
  onSubmit: (data: IAuthRegisterDto) => void;
};

function AuthRegisterForm({ loading, onSubmit }: AuthRegisterFormProps) {
  // use i18n
  const { t } = useTranslation(["auth", "common"]);

  // use react-hook-form
  const { control, watch, handleSubmit } = useForm<IAuthRegisterDto>({
    mode: "onBlur",
  });

  // watch confirm new password
  const watchPassword = watch("password", "");

  return (
    <Box>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={2}>
          <Box>
            <InputTextGroup
              name="firstName"
              label={t("form.label.firstName", {
                // TH: ชื่อ
                // EN: First name
                ns: "common",
              })}
              control={control}
              rules={{
                required: {
                  value: true,
                  message: t("form.message.required", { ns: "common" }),
                },
              }}
            ></InputTextGroup>
          </Box>
          <Box>
            <InputTextGroup
              name="lastName"
              label={t("form.label.lastName", {
                // TH: นามสกุล
                // EN: Last name
                ns: "common",
              })}
              control={control}
              rules={{
                required: {
                  value: true,
                  message: t("form.message.required", { ns: "common" }),
                },
              }}
            ></InputTextGroup>
          </Box>
          <Box>
            <InputTextGroup
              name="email"
              label={t("form.label.email", {
                // TH: อีเมล
                // EN: Email
                ns: "common",
              })}
              control={control}
              rules={{
                required: {
                  value: true,
                  message: t("form.message.required", { ns: "common" }),
                },
              }}
            ></InputTextGroup>
          </Box>
          <Box>
            <InputTextGroup
              name="mobileNumber"
              label={t("form.label.mobileNumber", {
                // TH: เบอร์โทรศัพท์
                // EN: Mobile number
                ns: "common",
              })}
              control={control}
              type="tel"
              rules={{
                required: {
                  value: true,
                  message: t("form.message.required", { ns: "common" }),
                },
              }}
            ></InputTextGroup>
          </Box>
          <Box>
            <InputTextGroup
              name="password"
              type="password"
              label={t("form.label.password", {
                ns: "common",
              })}
              control={control}
              rules={{
                required: {
                  value: true,
                  message: t("form.message.required", { ns: "common" }),
                },
              }}
            ></InputTextGroup>
          </Box>
          <Box>
            <InputTextGroup
              name="confirmPassword"
              type="password"
              label={t("form.label.confirmPassword", {
                ns: "common",
              })}
              control={control}
              rules={{
                required: {
                  value: true,
                  message: t("form.message.required", { ns: "common" }),
                },
                validate: (value: string) =>
                  value === watchPassword ||
                  t("form.message.passwordNotMatch", { ns: "common" }),
              }}
            ></InputTextGroup>
          </Box>
          <Box>
            <InputCheckboxGroup
              name="subscribe"
              label={t("auth.register.emailNewsletter")}
              control={control}
              rules={{}}
            />
          </Box>
          <Box>
            <Text fontSize="sm" mb={2}>
              {t("auth.register.agreement")}
            </Text>
          </Box>
          <Box>
            <Button type="submit" bg="black" width="100%" isLoading={loading}>
              {t("auth.register.button", {
                // TH: สมัครสมาชิก
                // EN: Register
              })}
            </Button>
          </Box>
          <Center>{t("auth.form.social.divider")}</Center>
          <AuthSocialLogin></AuthSocialLogin>
        </Stack>
      </form>
    </Box>
  );
}

export default AuthRegisterForm;
